import React, { useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import { Col, Row } from "react-bootstrap";
import nextImage from "../../Assets/Images/nextImage.svg";
import prevImage from "../../Assets/Images/prevImage.svg";
import logo from "../../Assets/Images/watermark logo-01.svg";
import "../../Assets/Styles/pages/header.scss";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import helper_functions from "../../Config/helper_functions";
import {
  setCreate,
  setTemplateReady,
} from "../../Redux/DownloadSlice/downloadSlice";
import {
  setBatchUrlImage,
  setTemplateForImage,
  skipBatchUrlImage,
  skipBatchUrlImageOne,
} from "../../Redux/MainImage/imageSlice";
import { setTemplateBatch } from "../../Redux/Templates/templateSlice";
import {
  setCreate_Template,
  setOnline,
  setTemplate_Changed,
  setTemplate_Edit,
} from "../../Redux/UserSlice/userSlice";
import {
  setActiveId,
  setWaterMarksLoader,
} from "../../Redux/WaterMarks/wateramarks";
import { CreateTemplate } from "../../actions/Template/Template";
import DownloadImage from "../DownloadImage/downloadImage";
import DownloadImageProgress from "../DownloadImageProgress/downloadImageProgress";
import NoInternetModal from "../NoInternetModal/noInternetModal";
import ProceedTemplate from "../ProceedTemplate/proceedTempalte";
import Profile from "../Profile/profile";
import SaveModal from "../SaveModal/saveModal";
import SettingsModal from "../SettingsModal/settingsModal";
import SignIn from "../SignIn/signIn";
import ButtonRounded from "../Signature/button";
import TemplateProgress from "../TemplateProgress/templateProgress";
import TemplateResponse from "../TemplateResponse/templateResponse";
import HeaderMobileView from "./HeaderMobileView";
import NewNameModal from "./NewNameModal";

const Header = ({ isMenuOpen, setIsMenuOpen }) => {
  const [open, setOpen] = useState(false);
  const [openSignIn, setOpenSignIn] = useState(false);
  const [openProceedTempalte, setOpenProceedTempalte] = useState(false);
  const [openProgress, setOpenProgress] = useState(false);
  const [batchindex, setBatchindex] = useState(null);
  const [loader, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [save, setSave] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);
  const [openTemplate, setOpenTemplate] = useState(false);
  const [respTemplate, setResponse] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [newTempName, setNewTempname] = useState("");
  const [newNameModal, setNewNameModal] = useState(false);

  const headerRef = useRef();

  let location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const history = useHistory();

  const file = useSelector((state) => state.mainImage);
  const mainImageState = useSelector((state) => state["mainImage"]);
  const waterMarksState = useSelector((state) => state["watermarks"]);
  const downloadState = useSelector((state) => state["downloadSlice"]);
  const userSliceState = useSelector((state) => state["userSlice"]);
  // dispatch(setLoader(false))

  const saveAsNew = () => {
    if (Object.keys(userSliceState.user_Auth).length) {
      if (waterMarksState.items.length) {
        setNewNameModal(false);
        dispatch(setCreate_Template(true));
        setOpenTemplate(true);
        // if (userSliceState.edit_Template) {
        //   setTimeout(() => {
        //     window.location.reload();
        //   }, 10000);
        // }
      } else {
        alert(t("NoWaterMarksTemplateError"));
      }
    } else {
      setOpenSignIn(true);
    }
  };

  useEffect(() => {
    const handleOnlineStatus = () => {
      setIsOnline(true);
      dispatch(setOnline(true));
    };
    const handleOfflineStatus = () => {
      setIsOnline(false);
      dispatch(setOnline(false));
    };

    window.addEventListener("online", handleOnlineStatus);
    window.addEventListener("offline", handleOfflineStatus);

    return () => {
      window.removeEventListener("online", handleOnlineStatus);
      window.removeEventListener("offline", handleOfflineStatus);
    };
  }, [navigator.onLine]);

  const condition = () => {
    if (location.pathname === "/edit") {
      if (file.batchurls.length > 0) return headerChoice3();
      else return headerChoice2();
    } else if (location.pathname === "/home") return headerChoice();
    else return headerChoice4();
  };
  const handleHome = async () => {
    history.push("/");
  };
  const handlePage = (page) => {
    setIsMenuOpen(false);
    history.push(page);
  };

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleCompleteEdit = (all) => {
    var id = Date.now();
    var index = batchindex;
    if (all) {
      index = -1;
    }
    dispatch(
      setTemplateForImage({
        index: index,
        tempID: id,
      })
    );
    var temp = {
      id: id,
      watermarks: waterMarksState.items,
    };
    dispatch(setTemplate_Edit(false));
    dispatch(setTemplateBatch(temp));
    setSave(false);
  };
  const handleIndex = (index) => {
    let newIndex = batchindex + index;
    // var old_id = userSliceState.current_TemplateID

    if (newIndex >= 0 && newIndex < file.batchurls.length) {
      dispatch(setWaterMarksLoader(true));
      dispatch(setBatchUrlImage(batchindex + index));
      setTimeout(() => {
        dispatch(setBatchUrlImage(batchindex + index));
      }, 100);
      setTimeout(() => {
        dispatch(setWaterMarksLoader(false));
      }, 2000);
      // dispatch(setLoader(true))
      // dispatch(GetTemplateDataFromRedux(id, templateSlice, waterMarksState, false))
      dispatch(setTemplate_Changed(true));
    }
  };

  const handleSkip = () => {
    if (file.batchurls.length > 1) {
      if (batchindex !== 0) {
        dispatch(skipBatchUrlImage(batchindex));
      } else {
        dispatch(skipBatchUrlImageOne(1));
      }
    } else if (file.batchurls.length === 1) {
      history.push("/");
    } else {
      alert("Cannot skip only one image.");
    }
  };

  useEffect(() => {
    setEdit(userSliceState.template_Edit);
  }, [userSliceState.template_Edit]);
  useEffect(() => {
    if (file.batchurls.length > 0) {
      setBatchindex(file.currentIndex);
    }
  }, [file.currentIndex]);

  useEffect(() => {
    if (loader) setOpen(true);
  }, [loader]);

  // THIS FUNCTIONAL ATOMATICALLY ASSIGNS A NEW NAME TO TEMPLATE BASED ON NUMBER
  function getNextTemplateName(templateArray = []) {
    let highestNumber = 0;

    if (templateArray?.length > 0) {
      templateArray.forEach((template) => {
        const templateNumber = parseInt(template.name.split(" ")[1]);
        if (!isNaN(templateNumber) && templateNumber > highestNumber) {
          highestNumber = templateNumber;
        }
      });
    }

    const nextTemplateNumber = highestNumber + 1;
    return `template ${nextTemplateNumber}`;
  }

  useEffect(async () => {
    if (downloadState.Image && downloadState.templateReady) {
      var sourcesArray = [];
      let watermarks = waterMarksState.items;
      const reversedArray = [];
      for (let i = watermarks.length - 1; i >= 0; i--) {
        // let src, data;
        var tempTemplate;
        let waterMarksId = uuidv4();
        if (watermarks[i].type === "image") {
          var { src, ...data } = { ...watermarks[i] };
          sourcesArray.push({
            local_id: waterMarksId,
            name: watermarks[i].name,
            src,
          });
          tempTemplate = {
            ...tempTemplate,
            media: {
              // "type": watermarks[i].property.charAt(0).toUpperCase() + watermarks[i].property.slice(1),
              type: watermarks[i].property,
              name: watermarks[i].name,
              bytes: watermarks[i].size,
            },
          };
        } else data = watermarks[i];

        data = await helper_functions.dataWrapperEncrypt(
          data,
          reversedArray.length,
          userSliceState.canvasSize
        );

        tempTemplate = {
          ...tempTemplate,
          // "name": data.property.charAt(0).toUpperCase() + data.property.slice(1),  //str.charAt(0).toUpperCase() + str.slice(1);
          name: data.property, //str.charAt(0).toUpperCase() + str.slice(1);
          localId: waterMarksId,
          type: data.type,
          // "type": data.type.charAt(0).toUpperCase() + data.type.slice(1),
          data: JSON.stringify(data),
        };
        if (
          userSliceState.edit_Template &&
          userSliceState.current_TemplateID &&
          watermarks[i].serverId
        ) {
          tempTemplate = {
            ...tempTemplate,
            serverId: watermarks[i].id,
          };
        }

        reversedArray.push(tempTemplate);
      }

      // dispatch(setCreate_Template(false));
      // dispatch(setEdit_Template(false));
      var img = await helper_functions.resizeFile(
        downloadState.Image,
        100,
        100,
        "png",
        10
      );
      const size_thumb = helper_functions.dataURLtoFile(img, "image.png").size;
      const size_large = helper_functions.dataURLtoFile(
        downloadState.Image,
        "image.png"
      ).size;
      var name;
      if (
        userSliceState?.edit_Template &&
        !userSliceState.create_Template &&
        userSliceState.template
      ) {
        name = userSliceState.template;
        name = name?.filter((template) => {
          return userSliceState?.current_TemplateID === template.id;
        })[0].name;
      } else {
        name = newTempName.length > 0 ? newTempName : getNextTemplateName();
      }
      let templateData = {
        id:
          userSliceState.current_TemplateID &&
          userSliceState.edit_Template &&
          !userSliceState.create_Template
            ? userSliceState.current_TemplateID
            : uuidv4(),
        name: name,
        platform: "web",
        orientation:
          mainImageState.orientation === "landscape" ? "landScape" : "portrait",
        templateType: "fixed",
        media: {
          thumbSizeInBytes: size_thumb,
          originalSizeInBytes: size_large,
        },
        // "thumb_size_in_bytes": size_thumb,
        // "large_size_in_bytes": size_large,
        // "media_name": "media.png"
      };

      templateData = {
        ...templateData,
        watermarks: reversedArray,
      };

      if (userSliceState.edit_Template && userSliceState.current_TemplateID) {
        templateData = {
          ...templateData,
          deletedIds: waterMarksState.deletedWaterMarkIds,
        };
      }
      const resp = await dispatch(
        CreateTemplate(
          templateData,
          downloadState.Image,
          img,
          sourcesArray,
          userSliceState
        )
      );
      setResponse(resp);
      setOpenTemplate(false);
    }
  }, [downloadState.templateReady, downloadState.Image]);

  const handleTemplate = () => {
    dispatch(setCreate(-2));
    dispatch(setTemplateReady(true));
  };

  const headerChoice = () => {
    return (
      <Row
        ref={headerRef}
        className="header m-0 d-flex bg-white landing_header border-bottom"
      >
        <Col className="d-flex flex-column align-items-start justify-content-center">
          <Row className="d-flex productSansBold text_22 justify-content-center align-items-center pointer">
            <Col className="p-0">
              <img
                onClick={handleHome}
                src={logo}
                alt="logo"
                className="logo"
              />
            </Col>
            <Col onClick={handleHome} className="logo_text mx-1 m-0 p-0">
              {" "}
              {t("lang.ezywatermark")}
            </Col>
          </Row>
        </Col>
        <Col className="d-flex flex-column align-items-end justify-content-center">
          <Row className="d-flex flex-row-reverse text_15 productSansLight text-black justify-content-end align-items-center flex-nowrap">
            <Col className="ms-4 p-0">
              {!Object.keys(userSliceState.user_Auth).length ? (
                <button
                  onClick={() => {
                    setOpenSignIn(true);
                  }}
                  className="button_text  d-flex justify-content-center align-items-center button_text_signin w-100 px-4 py-3"
                >
                  {t("header.SignIn")}
                </button>
              ) : (
                <Profile setOpenSettings={setOpenSettings} anchor={headerRef} />
              )}
            </Col>
            {/* <Col className="ms-4 me-3 p-0">
            <button
              onClick={() => handlePage("/pricing")}
              className='button_text ' >{t("header.UpgradeToPro")}</button>
          </Col> */}
            <Col className="ms-4 me-3 p-0">
              <button onClick={() => handlePage("/")} className="button_text ">
                {t("header.Home")}
              </button>
            </Col>
          </Row>
        </Col>
        <SignIn open={openSignIn} setOpen={setOpenSignIn} />
        <SettingsModal
          open={openSettings}
          setOpen={setOpenSettings}
          handleDone={() => setOpenSettings(false)}
          parent={false}
        />
      </Row>
    );
  };

  const headerChoice2 = () => {
    return (
      <Row
        ref={headerRef}
        onClick={() => {
          dispatch(setActiveId(""));
        }}
        className="header landing_header m-0 d-flex bg-white "
      >
        <Col className="d-flex flex-column align-items-start justify-content-center ">
          <Row className="d-flex productSansBold text_22 justify-content-center align-items-center pointer flex-nowrap">
            <Col onClick={handleHome} className="p-0">
              <img alt="logo" src={logo} className="logo" />
            </Col>
            <Col onClick={handleHome} className="logo_text  mx-1  m-0 p-0">
              {" "}
              {t("lang.ezywatermark")}
            </Col>
          </Row>
        </Col>
        <Col className="d-flex flex-column align-items-end justify-content-center p-0 m-0">
          <Row className="d-flex p-0 m-0 text_15 productSansLight justify-content-center align-items-center flex-nowrap">
            {userSliceState.edit_Template && (
              <Col>
                <button
                  onClick={() => {
                    setNewNameModal(true);
                  }}
                  className="button_text w_edit_button m-0 py-1 bg_templ d-flex justify-content-center align-items-center button_text_signin"
                >
                  Save as New
                </button>
              </Col>
            )}
            {(userSliceState.edit_Template ||
              userSliceState.create_Template) && (
              <Col>
                <button
                  onClick={() => {
                    if (Object.keys(userSliceState.user_Auth).length) {
                      if (waterMarksState.items.length) {
                        setOpenTemplate(true);
                        // if (userSliceState.edit_Template) {
                        //   setTimeout(() => {
                        //     window.location.reload();
                        //   }, 10000);
                        // }
                      } else {
                        alert(t("NoWaterMarksTemplateError"));
                      }
                    } else {
                      setOpenSignIn(true);
                    }
                  }}
                  className="button_text w_edit_button m-0 py-1  bg_templ d-flex justify-content-center align-items-center button_text_signin"
                >
                  {t("UpdateTemplate")}
                </button>
              </Col>
            )}
            {!(
              userSliceState.edit_Template || userSliceState.create_Template
            ) ? (
              <Col>
                <button
                  className="button_text w_edit_button m-0 py-1  bg_proceed d-flex justify-content-center align-items-center button_text_signin"
                  onClick={() => {
                    if (waterMarksState.items.length) setLoading(true);
                    else {
                      if (window.confirm(t("NoWaterMarksProceedError")))
                        setLoading(false);
                    }
                  }}
                >
                  {loader ? (
                    <CircularProgress size={24} />
                  ) : (
                    t("header.Proceed")
                  )}
                </button>
              </Col>
            ) : null}

            <Col className="p-0 mr_2vw m-0">
              {!Object.keys(userSliceState.user_Auth).length ? (
                <button
                  onClick={() => {
                    setOpenSignIn(true);
                  }}
                  className="button_text h-100 d-flex justify-content-center align-items-center button_text_signin w-100 px-4 py-1"
                >
                  {t("header.SignIn")}
                </button>
              ) : (
                <Profile setOpenSettings={setOpenSettings} anchor={headerRef} />
              )}
            </Col>
          </Row>
        </Col>
        <DownloadImage
          loader={loader}
          setLoaderParent={setLoading}
          open={open}
          setOpen={setOpen}
          setOpenProgress={setOpenProgress}
        />
        <NewNameModal
          open={newNameModal}
          setOpen={setNewNameModal}
          name={newTempName}
          setName={setNewTempname}
          onComplete={saveAsNew} // When user saves the name this function will be called
        />
        <ProceedTemplate
          open={openProceedTempalte}
          setOpen={setOpenProceedTempalte}
        />
        <DownloadImageProgress
          open={openProgress}
          setOpenProgress={setOpenProgress}
          setOpen={setOpen}
        />
        <SignIn open={openSignIn} setOpen={setOpenSignIn} />
        <SettingsModal
          open={openSettings}
          setOpen={setOpenSettings}
          handleDone={() => setOpenSettings(false)}
          parent={false}
        />
        <TemplateProgress
          open={openTemplate}
          setOpen={setOpenTemplate}
          handleTemplate={handleTemplate}
        />
        <TemplateResponse open={respTemplate} setOpen={setResponse} />
      </Row>
    );
  };
  const headerChoice3 = () => {
    return (
      <Row
        ref={headerRef}
        onClick={() => {
          dispatch(setActiveId(""));
        }}
        className="header m-0 p-0 d-flex bg-white "
      >
        <Col className="d-flex flex-column align-items-start justify-content-center mx-3 px-2">
          <Row className="d-flex productSansBold text_22 justify-content-center align-items-center pointer flex-nowrap">
            <Col onClick={handleHome}>
              <img alt="logo" src={logo} className="logo" />
            </Col>
            <Col onClick={handleHome} className="logo_text mx-1  m-0 p-0">
              {" "}
              {t("lang.ezywatermark")}
            </Col>
          </Row>
        </Col>
        <Col>
          <Row className="d-flex text_18 productSansMedium justify-content-center align-items-center flex-nowrap h-100">
            {batchindex + 1 <= file.batchurls.length
              ? "Image " + (batchindex + 1) + " of " + file.batchurls.length
              : "Processing Done"}
          </Row>
        </Col>
        <Col className="d-flex flex-column align-items-end justify-content-center  mx-3 px-2">
          <Row className="d-flex text_19 productSansLight justify-content-center align-items-center flex-nowrap">
            {!userSliceState.template_Edit && (
              <>
                <Col className="mx-2 m-0 p-0">
                  <button
                    onClick={() => handleIndex(-1)}
                    className="button_text m-0 bg_batch batchControlsSmall border-0 d-flex justify-content-center align-items-center button_text_signin"
                  >
                    <img
                      alt="previous"
                      src={prevImage}
                      className="batchControlsSmallIcon"
                    />
                  </button>
                </Col>
                <Col className="mx-2 m-0 p-0">
                  <button
                    onClick={() => handleIndex(+1)}
                    className="button_text m-0 bg_batch batchControlsSmall border-0 d-flex justify-content-center align-items-center button_text_signin"
                  >
                    <img
                      alt="next"
                      src={nextImage}
                      className="batchControlsSmallIcon"
                    />
                  </button>
                </Col>
              </>
            )}
            {/* <Col className=" m-0  mx-2 p-0">
							<ButtonRounded
								onclick={handleTemplateClick}
								text={edit ? "Save" : t("Edit")}
								style={"w_edit_button bg_batch my-0 mb-0 p-0"}
								parrentStyle={""}
							/>
						</Col> */}
            {!edit ? (
              <Col className=" m-0 mx-2 p-0">
                <ButtonRounded
                  onclick={handleSkip}
                  text={"Skip"}
                  style={"w_edit_button bg_batch my-0 mb-0 p-0"}
                  parrentStyle={" "}
                />
              </Col>
            ) : null}
            <Col className="mx-2 m-0 p-0">
              <Profile setOpenSettings={setOpenSettings} anchor={headerRef} />
            </Col>
          </Row>
        </Col>
        <SaveModal
          open={save}
          setOpen={setSave}
          handleCompleteEdit={handleCompleteEdit}
        />
        <SettingsModal
          open={openSettings}
          setOpen={setOpenSettings}
          handleDone={() => setOpenSettings(false)}
          parent={false}
        />
      </Row>
    );
  };
  const headerChoice4 = () => {
    return (
      <Row
        ref={headerRef}
        className="header m-0 d-flex bg-white landing_header border-bottom"
      >
        <Col className="d-flex flex-column align-items-start justify-content-center">
          <Row className="d-flex productSansBold text_22 justify-content-center align-items-center pointer">
            <Col className="p-0">
              <img
                alt="logo"
                onClick={handleHome}
                src={logo}
                className="logo"
              />
            </Col>
            <Col onClick={handleHome} className="logo_text mx-1 m-0 p-0">
              {" "}
              {t("lang.ezywatermark")}
            </Col>
          </Row>
        </Col>
        <Col className="d-flex flex-column align-items-end justify-content-center">
          <Row className="d-flex flex-row-reverse text_15 productSansLight text-black justify-content-end align-items-center flex-nowrap">
            <Col className="ms-4 p-0">
              {!Object.keys(userSliceState.user_Auth).length ? (
                <button
                  onClick={() => {
                    setOpenSignIn(true);
                  }}
                  className="button_text d-flex justify-content-center align-items-center button_text_signin w-100 px-4 py-3"
                >
                  {t("header.SignIn")}
                </button>
              ) : (
                <Profile setOpenSettings={setOpenSettings} anchor={headerRef} />
              )}
            </Col>
            <Col className="ms-4 me-3 p-0">
              <button
                onClick={() =>
                  (window.location.href = `${process.env.REACT_APP_GHOST_API_URL}`)
                }
                className={` ${
                  location.pathname === "/blogs" && "highlightedHeaderText"
                }  button_text `}
              >
                {t("Blogs")}
              </button>
            </Col>
            <Col className="ms-4 me-3 p-0">
              <button
                onClick={() => handlePage("/faq")}
                className={` ${
                  location.pathname === "/faq" && "highlightedHeaderText"
                }  button_text `}
              >
                {t("FAQ")}
              </button>
            </Col>
            <Col className="ms-4 me-3 p-0">
              <button
                onClick={() => handlePage("/pricing")}
                className={` ${
                  location.pathname === "/pricing" && "highlightedHeaderText"
                }  button_text `}
              >
                {t("Pricing")}
              </button>
            </Col>
            <Col className="ms-4 me-3 p-0">
              <button
                onClick={() => handlePage("/features")}
                className={` ${
                  location.pathname === "/features" && "highlightedHeaderText"
                }  button_text `}
              >
                {t("Features")}
              </button>
            </Col>
          </Row>
        </Col>

        <SignIn open={openSignIn} setOpen={setOpenSignIn} />
        <SettingsModal
          open={openSettings}
          setOpen={setOpenSettings}
          handleDone={() => setOpenSettings(false)}
          parent={false}
        />
      </Row>
    );
  };
  return (
    <>
      <div className="d-lg-block d-none header">{condition()}</div>
      <div className="d-lg-none header">
        <HeaderMobileView
          handlePage={handlePage}
          setOpenSettings={setOpenSettings}
          setOpenSignIn={setOpenSignIn}
          handleMenuToggle={handleMenuToggle}
          setIsMenuOpen={setIsMenuOpen}
          isMenuOpen={isMenuOpen}
        />
        <NoInternetModal open={!isOnline} setOpen={setIsOnline} />
      </div>
    </>
  );
};

export default Header;
